var GrayBgImageScaler = (function () {
  

  var Utility = window.Utility || {};

  Utility.log('GrayBgImageScaler js loaded');

  var bgObserver = null;

  // configuration of the observer:
  var bgObserverConfig = {
    attributes: true,
    childList: false,
    characterData: false,
  };

  var toutSelector = 'section[data-rzf-gry-tout-tier="1"], section[data-rzf-gry-tout-tier="2"], article.rzf-gry.rzf-gry-tout-tile.image-scale-element';
  var $toutBackgroundContainers = $('.tout-background.image-scale-element', toutSelector);
  var toutBackgrounds = [];

  function observeTouts() {
    $toutBackgroundContainers.each(function (i, el) {
      $(el).data('tout-one-bg-observer-index', i);
      toutBackgrounds[i] = null;
      bgObserver.observe(el, bgObserverConfig);
    });
  }

  function scaleToutBg(el, i) {
    var $el = $(el);
    toutBackgrounds[i] = $(el).css('background-image');
    var bgImage = getBgImage(el);
    bgImage.onload = function () {
      var bgRatio = getBgImageRatio(this);
      $el.height('auto');
      $el.parent().height('auto !important');
      $el.css('padding-top', bgRatio * 100 + '%');
    };
  }

  function initBgMutationObserver() {
    // create an observer instance
    bgObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var el = mutation.target;
        if ((mutation.type === 'attributes') && (mutation.attributeName === 'style')) {
          if ($(el).css('background-image')) {
            // Expand if-else here for other components.
            if ($(el).closest(toutSelector)) {
              var index = $(el).data('tout-one-bg-observer-index');
              if (toutBackgrounds[index] !== $(el).css('background-image')) {
                scaleToutBg(el, index);
              }
            }
          }
        }
      });
    });
  }

  function getBgImage(el) {
    var image = new Image();
    var bg = ($(el).css('background-image'))
      .replace(/.*\s?url\(['"]?/, '')
      .replace(/['"]?\).*/, '');

    if (bg && bg !== '') {
      image.src = bg;
    }

    return image;
  }

  function getBgImageRatio(img) {
    return parseFloat(img.height / img.width).toFixed(4);
  }

  function init() {
    initBgMutationObserver();
    observeTouts();
  }

  return {
    init: init,
  };
}());
